module.exports = __webpack_public_path__ + "img/9788983928559.7c2f4a3f.jpg";